import React, { useState, useEffect } from "react";
import Header from "../components/utils/Header";
import Footer from "../components/utils/Footer";
import Section from "../components/teamManagement/Section";
import MemberList from "../components/teamManagement/MemberList";
import { collection, onSnapshot } from "firebase/firestore";
import { database } from "../database/firebase-config";
import { useFirebase } from "../database/FirebaseContext";
import { getLocalUser } from "../database/localStorage";
import ResetPasswordForm from "../components/teamManagement/ResetPasswordForm";
import WorkingTimeGraph from "../components/teamManagement/WorkingTimeGraph";

function TeamManagement({colourBlindMode, onColourBlindMode, offColourBlindMode}) {
	document.title = "Team Management";

	const [modalChangePassword, setModalChangePassword] = useState("false");

	const openModalChangePassword = () => {
		setModalChangePassword(true);
	};

	// make the task detail hidden
	const closeModalChangePassword = () => {
		setModalChangePassword(false);
	};

	const { getUser, getAllUsersData } = useFirebase();
	const [users, setUsers] = useState([]);
	const [userRoles, setUserRoles] = useState("");
	const [currentUser, setCurrentUser] = useState({});
	const [modalWorkingTimeGraph, setModalWorkingTimeGraph] = useState(false);
	const [selectedUser, setSelectedUser] = useState({
		userID: "",
		userName: "",
		userRole: "",
		userEmail: "",
		userPassword: "",
		userWorkingHour: 0,
	});

	// for avg time span graph
	const [usersAvg, setUsersAvg] = useState([]);

	// reveal the task detail
	const openmodalWorkingTimeGraph = (user) => {
		// console.log(user);
		setSelectedUser(user);
		setModalWorkingTimeGraph(true);
	};

	// make the task detail hidden
	const closemodalWorkingTimeGraph = () => {
		setSelectedUser(null);
		setModalWorkingTimeGraph(false);
	};

	useEffect(() => {
		const collectionRef = collection(database, "users");
		const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
			const data = snapshot.docs.map((doc) => ({
				...doc.data(),
				id: doc.id,
			}));
			data.sort(
				(a, b) =>
					(a.createdAt?.toMillis() || 0) -
					(b.createdAt?.toMillis() || 0)
			);
			setUsers(data);
		});

		const updateCurrentUser = async () => {
			const user = await getUser(
				getLocalUser().userName,
				getLocalUser().userPassword
			);
			setCurrentUser(user);
			setUserRoles(user.userRole);
		};

		const getUserAvgData = async () => {
			const usersAvgData = await getAllUsersData();
			setUsersAvg(usersAvgData);
		};

		updateCurrentUser();
		getUserAvgData();
		return () => unsubscribe();
	}, []);

	return (
		<div>
			<Header
				roles={currentUser.userRole}
				openModal={openModalChangePassword}
				colourBlindMode={colourBlindMode}
                onColourBlindMode={onColourBlindMode}
                offColourBlindMode={offColourBlindMode}
			/>
			<Section
				users={usersAvg}
				title={"Team Management"}
				roles={userRoles}
			/>
			{modalChangePassword === true && (
				<ResetPasswordForm onClose={closeModalChangePassword} />
			)}

			{modalWorkingTimeGraph === true && (
				<WorkingTimeGraph
					users={usersAvg?.filter((user) => user.userName === selectedUser.userName)[0]}
					onClose={closemodalWorkingTimeGraph}
					colourBlindMode={colourBlindMode}
				/>
			)}

			<div class=" flex relative">
				<div class="overflow-y-scroll w-full h-[80vh]">
					<MemberList
						openmodalWorkingTimeGraph={openmodalWorkingTimeGraph}
						users={users}
						roles={userRoles}
					/>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default TeamManagement;
